function DazRatings() {
    this.firstLoad = true;
    this.productId = 0;
    this.canReview = false;
    this.myRating = 0;
    this.rating = 0;
    this.count = 0;
}

DazRatings.prototype.rate = function (rating) { // -1 = dislike, 0 = remove like, 1 = like
    return new Promise((resolve, reject) => {

        this.productId = parseInt(this.productId, 10);
        if (this.productId <= 0 || isNaN(this.productId)) {
            return;
        }
        if (!this.canReview) {
            return;
        }
        if ((this.myRating === 1 && rating === -1) || (this.myRating === 5 && rating === 1) ) {
            rating = 0;
        }

        $.ajax(`/dazApi/reviews/${this.productId}/save`, {method: 'POST', data: {rating}}).done((response) => {
            this.canReview = response.can_review;
            this.myRating = response.my_rating;
            this.rating = response.rating;
            this.firstLoad = false;
            document.dispatchEvent(new CustomEvent("dazRatingLoaded", {detail: {rating: this}}));
            resolve(this);
        }).fail(function(x) {
            reject({xhr: x, rating: this});
        });
    });
}

DazRatings.prototype.load = function (callData, data, isCache) {
    this.productId = parseInt(this.productId, 10);
    if (this.productId <= 0 || isNaN(this.productId) || isCache) {
        return;
    }
    $.ajax('/dazApi/reviews/' + parseInt(this.productId, 10)).done((response) => {
        this.canReview = response.can_review;
        this.myRating = response.my_rating;
        this.rating = response.rating;
        this.count = response.count;
        document.dispatchEvent(new CustomEvent("dazRatingLoaded", {detail: {rating: this}}));
        this.firstLoad = false;
    });
}

DazRatings.prototype.init = function (id, rating = 0) {
    this.productId = parseInt(id, 10);
    this.rating = rating;
    $(window).on('beforeDazApi', () => {
        daz.api.addCall('Catalog/owned', {callbackClass: this, callbackFunc: this.load});
    });
}
